module.exports = __webpack_public_path__ + "static/media/6.e4d08eb8.jpg";